@if (!iconButton) {
  <button type="button" mat-flat-button color="primary" (click)="fileInput.click()"><ng-content></ng-content></button>
}
@if (iconButton) {
  <button type="button" mat-icon-button color="primary" (click)="fileInput.click()"><mat-icon>add</mat-icon></button>
}
<input hidden type="file" #fileInput multiple (change)="filesLoaded($event)">
